import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface BasicTemplateInfoProps {
  onFieldChange: (field: string, value: string) => void;
  initialName?: string;
}

export const BasicTemplateInfo = ({ onFieldChange, initialName = "" }: BasicTemplateInfoProps) => {
  const [name, setName] = useState(initialName);

  // Update state when initial values change (e.g., when loading from database)
  useEffect(() => {
    if (initialName) setName(initialName);
  }, [initialName]);

  const handleNameChange = (value: string) => {
    setName(value);
    onFieldChange("name", value);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Basic Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <label className="text-sm font-medium">Name</label>
          <Input
            type="text"
            placeholder="Template name"
            value={name}
            onChange={(e) => handleNameChange(e.target.value)}
          />
        </div>
      </CardContent>
    </Card>
  );
};
